import {
    SetCompiled, SetTables, SetTickerSize, SetInc, SetWebSocket,
} from 'store/features/tables'
import ListManager from 'utils/tables/list-manager'
import deepClone from 'utils/deep-clone'

const setCompiledObject = (id: string, asks: number[][], bids: number[][]) => ({
    id,
    values: {
        asks:
            {
                title: 'asks',
                sortBy: 'ASC',
                values: deepClone(asks),
            },
        bids:
            {
                title: 'bids',
                sortBy: 'DESC',
                values: deepClone(bids),
            },
    },
})

export const WsManager = (
    id: string,
    current: string,
    url: string,
    pair: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch: any
) => {

    let state = {
        id: '',
    };

    let counter = 0
    let asks: number[][] = []
    let bids: number[][] = []

    let ws: { onopen: () => void; send: (arg0: string) => void; close: () => void; } | null = null;

    subscribeStream(url, id, current, pair, dispatch);

    function subscribeStream(url: string, id: string, current: string, pair: string, dispatch: any) {

        dispatch(SetInc({ id, current }))
        dispatch(SetTickerSize({ id, ticker: 0 }))

        state.id = ''
        const ws = new WebSocket(url);
        const s = pair.toLowerCase() + '@depth';

        const msg = {
            method: 'SUBSCRIBE',
            params: [s],
            id: 1,
        };

        ws.onopen = () => {
            ws.send(JSON.stringify(msg));
            dispatch(SetWebSocket({ id, ws }))
        }

        ws.onmessage = (event) => {
            main(id, current, pair, dispatch, event)
        }
    }

    function unsubscribeStream(pair: string) {
        if (ws) {
            let s = pair.toLowerCase() + '@depth';
            const msg = {
                method: 'UNSUBSCRIBE',
                params: [s],
                id: 1,
            }
            ws.onopen = () => {
                ws?.send(JSON.stringify(msg));
            };
            ws.close()
            state.id = '';
        }
    }

    function main(id: string, current : string, pair : string, dispatch: any, event: any) {

        const UIRefreshRate = 1; // 30

        const json = JSON.parse(event.data)

        try {
            // eslint-disable-next-line no-console
            // if ((json.event === 'data')) {

            if (state.id == '') {
                // eslint-disable-next-line no-console
                //console.log('snapshot')
                getSnapshot(id, pair, dispatch)
                state.id = id
            } else {
                // eslint-disable-next-line no-console
                //console.log('update')
                if (counter <= UIRefreshRate) {
                    counter += 1
                }

                asks = deepClone(ListManager(asks, json.a.map((d: any[]) => d.map(Number))))
                bids = deepClone(ListManager(bids, json.b.map((d: any[]) => d.map(Number))))

                dispatch(SetCompiled(setCompiledObject(id, asks, bids)))

                if (counter === UIRefreshRate) {
                    dispatch(SetTables({current: current, id: id}))
                    counter = 0
                }
            }
            // }
        } catch (err) {
            // console.log(err)
        }
    }

    const getSnapshot = async (id: string, pair: string, dispatch: any) => {
        const res = await fetch(`https://api.binance.us/api/v3/depth?symbol=${pair}&limit=1000`
        );
        const obsnapshot = await res.json();
        //const {bids: bidsS, asks: asksS} = obsnapshot;
        const asks = deepClone(obsnapshot.asks.map((d: any[]) => d.map(Number)));
        const bids = deepClone(obsnapshot.bids.map((d: any[]) => d.map(Number)));
        //asks = deepClone(obsnapshot.asks)
        //bids = deepClone(obsnapshot.bids)

        dispatch(SetCompiled(setCompiledObject(id, asks, bids)))

    };

}



